'use client'

import {useFormContext} from 'react-hook-form'

import type {
  CaptchaRenderProps,
  LoginBeginData,
  LoginFormData,
} from '@/src/features/auth/core/login-types'
import {useCaptcha} from '@/src/shared/modules/captcha'
import {handleMutationException} from '@/src/shared/utils/error'

type UseLoginFormSubmitParams = {
  onSubmitAction: (
    data: LoginFormData,
    captchaToken: string,
  ) => Promise<(LoginBeginData & {phone: string}) | null>
  onNext: (props: LoginBeginData & {phone: string}) => void
}

type UseLoginFormSubmitResult = {
  onSubmit: () => void
  isTokenReady: boolean
  captchaProps: CaptchaRenderProps
}

export const useLoginFormSubmit = ({
  onSubmitAction,
  onNext,
}: UseLoginFormSubmitParams): UseLoginFormSubmitResult => {
  const form = useFormContext<LoginFormData>()
  const {token, onSuccessToken, visibleCaptcha, setVisibleCaptcha, renderKey, reset} = useCaptcha()

  const onSubmit = form.handleSubmit(
    async data => {
      try {
        const result = await onSubmitAction(data, token!)
        if (result) {
          onNext(result)
        }
      } finally {
        reset()
      }
    },
    () => {
      handleMutationException('Форма заполнена некорректно')
    },
  )

  return {
    onSubmit,
    isTokenReady: !!token,
    captchaProps: {
      renderKey,
      onSuccess: onSuccessToken,
      visible: visibleCaptcha,
      setVisible: setVisibleCaptcha,
    },
  }
}
